import { Link } from 'react-router-dom';
import {
  GetTestAttemptInspectQuery,
  TestAttemptStatus,
} from '../../apollo/__generated__/graphql.ts';
import LocalDate from '../common/local-date.tsx';
import { cn } from '../../utils/common-utils.ts';
import { useFragment } from '../../apollo/__generated__';
import { InspectTestAttemptDetailsFragment } from '../../apollo/test-attempt.ts';
import { RoutesEnum } from '../../utils/enums.ts';

interface IProps {
  data?: GetTestAttemptInspectQuery['testAttempt']['getAttempt'];
}
export const InspectTestDetails = ({ data }: IProps) => {
  const details = useFragment(InspectTestAttemptDetailsFragment, data);
  return (
    <div className="space-y-4 rounded-xl border border-light-gray bg-white p-4 text-sm">
      <div>
        <div className="text-xs font-bold uppercase text-gray">Test Name</div>
        <div className="mt-0.5">{details?.test.name}</div>
      </div>

      <div>
        <div className="text-xs font-bold uppercase text-gray">User</div>
        <div className="mt-0.5">
          {details?.createdBy && (
            <Link
              target={'_blank'}
              className={'font-medium text-blue'}
              to={`/users-browser/${details.createdBy.id}`}
            >
              {details.createdBy.name}
            </Link>
          )}
        </div>
      </div>

      {details?.rwScore ? (
        <div>
          <div className="text-xs font-bold uppercase text-gray">
            R. & W. Score
          </div>
          <div className="mt-0.5">
            {details.rwScore} ({details.rwModuleLevel})
          </div>
        </div>
      ) : null}

      {details?.mathScore ? (
        <div>
          <div className="text-xs font-bold uppercase text-gray">
            Math Score
          </div>
          <div className="mt-0.5">
            {details.mathScore} ({details.mathModuleLevel})
          </div>
        </div>
      ) : null}

      {details?.createdAt && (
        <div>
          <div className="text-xs font-bold uppercase text-gray">
            Started on
          </div>
          <div className="mt-0.5">
            <LocalDate date={details.createdAt} format="PPP 'at' p" />
          </div>
        </div>
      )}

      {details?.rwScore ? (
        <>
          <div>
            <div className="text-xs font-bold uppercase text-gray">
              R. & W. Mod. 1 Next Trigger
            </div>
            <div className="mt-0.5">{details.rw1NextTrigger}</div>
          </div>

          <div>
            <div className="text-xs font-bold uppercase text-gray">
              R. & W. Mod. 2 Next Trigger
            </div>
            <div className="mt-0.5">{details.rw2NextTrigger}</div>
          </div>
        </>
      ) : null}

      {details?.mathScore ? (
        <>
          <div>
            <div className="text-xs font-bold uppercase text-gray">
              Math Mod. 1 Next Trigger
            </div>
            <div className="mt-0.5">{details.math1NextTrigger}</div>
          </div>

          <div>
            <div className="text-xs font-bold uppercase text-gray">
              Math Mod. 2 Next Trigger
            </div>
            <div className="mt-0.5">{details.math2NextTrigger}</div>
          </div>
        </>
      ) : null}

      <span
        className={cn(
          'mr-2 inline-block w-24 select-none rounded-xl p-1 text-center text-xs text-white',
          details?.status === TestAttemptStatus.Completed
            ? 'bg-green'
            : 'bg-blue',
        )}
      >
        {details?.status}
      </span>
      <div className="flex flex-col gap-y-2">
        {details?.status === TestAttemptStatus.Completed && (
          <div
            className={'link-white-button'}
            onClick={() => {
              window.open(
                `${import.meta.env.VITE_BASE_URL}${RoutesEnum.TEST_ATTEMPT_ATTEMPT_ID_ANSWER_REPORT.replace(':attemptId', `${details.id}`)}`,
                '_blank',
              );
            }}
          >
            Answer Report
          </div>
        )}

        {details?.status === TestAttemptStatus.Completed && (
          <div
            className={'link-white-button'}
            onClick={() => {
              window.open(
                `${import.meta.env.VITE_BASE_URL}${RoutesEnum.TEST_ATTEMPT_ATTEMPT_ID_SCORE_REPORT.replace(':attemptId', `${details.id}`)}`,
                '_blank',
              );
            }}
          >
            Score Report
          </div>
        )}
      </div>
    </div>
  );
};
